/*
 * userEntityAssignments Reducer
 */
import {
    USER_ENTITY_ASSIGNMENTS_SET,
    USER_ENTITY_ASSIGNMENTS_MERGE
} from './constants';

import {
    UserEntityAssignment,
    UserEntityAssignmentsState,
    UserEntityAssignmentsAction,
    EntityGroupedUserAssignment
} from './types';

import { RESET_STATE } from '../auth/constants';

const initialState: UserEntityAssignment[] = [];

export default function (
    state: UserEntityAssignmentsState = initialState,
    action: UserEntityAssignmentsAction
): UserEntityAssignmentsState {
    switch (action.type) {
        case USER_ENTITY_ASSIGNMENTS_SET:
            return action.payload as UserEntityAssignment[];
        case USER_ENTITY_ASSIGNMENTS_MERGE: {
            const updatedEntityIds = (action.payload as EntityGroupedUserAssignment[]).map(
                (item) => item.entityId
            );

            const updatedUserAssignments: UserEntityAssignment[] = [];
            (action.payload as EntityGroupedUserAssignment[]).forEach(
                (assignmentPerEntity) => {
                    const { userAssignments } = assignmentPerEntity;
                    const userAssignmentsWithEntityId = userAssignments.map(
                        (assignment) => ({
                            ...assignment,
                            entityId: assignmentPerEntity.entityId
                        })
                    );
                    updatedUserAssignments.push(...userAssignmentsWithEntityId);
                }
            );

            return (
                state
                    // Clear any old assignments related to updated entities
                    .filter(
                        (userEntityAssignment) =>
                            !updatedEntityIds.includes(
                                userEntityAssignment.entityId
                            )
                    )
                    // Merge existing assignments on updated entities
                    .concat(updatedUserAssignments)
            );
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
